import { useState } from 'react';

import { ViewLayout } from '../components/ViewLayout';
import { useUrlPageState, useUrlSortState, useUrlFilterState } from '../common/filtering/filter';
import { OfflineDeviceTable } from '../components/OfflineDeviceTable';

function Content() {
  const [now, setNow] = useState(new Date());
  const queryProps = useUrlFilterState();
  const pageProps = useUrlPageState();
  const sortProps = useUrlSortState('time_offline', 'desc');

  return (
    <OfflineDeviceTable {...queryProps} {...pageProps} {...sortProps} now={now} setNow={setNow} />
  );
}

export default function OfflinePage() {
  return (
    <ViewLayout breadcrumbs={[{ text: 'Offline Devices', href: '' }]} contentType="table">
      <Content />
    </ViewLayout>
  );
}
